import axios from 'axios'

const API_PATH = 'api/v2/admins/customers/orders/payments'

const CustomerOrderPaymentsApiV2 = {

  /**
   * Creates a Customer Order Payment single Customer Order Payment based on `Customer::Order::Payment.id`
   * Invoke `POST api/v2/admins/customers/orders/payments
   * @param {number} id - Customer Order Payment
   */
  create: ({ order, payment_method }) => {
    const path     = `${API_PATH}`
    const params   = {
      customer_order_id    : order.id,
      tl_payment_method_id : payment_method.id
    }
    const response = axios.post(path, params)
    return response
  },

  /**
   * Updates Customer Order Payment `status`
   * Invoke `PATCH api/v2/admins/customers/orders/payments/:id
   * @param {number} id - Customer Order Payment
   * @param {number} status - new status to update to
   */
  update: (values) => {
    const id   = values.id
    const path = `${API_PATH}/${id}`
    const body = {
      payment: values
    }

    const response = axios.patch(path, body)
    return response
  }
}

export default CustomerOrderPaymentsApiV2
